var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDescription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.893,
    height: 9.952,
    viewBox: "0 0 20.893 9.952",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "description",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    d: "M255,255.068a1.1,1.1,0,0,1-1.1,1.1h-18.7a1.1,1.1,0,0,1,0-2.19h18.7A1.1,1.1,0,0,1,255,255.068Z",
    transform: "translate(-234.111 -253.973)",
    fill: "rgba(0,0,0,0.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    "data-name": "Path 2231",
    d: "M255,255.068a1.1,1.1,0,0,1-1.1,1.1h-18.7a1.1,1.1,0,0,1,0-2.19h18.7A1.1,1.1,0,0,1,255,255.068Z",
    transform: "translate(-234.111 -250.391)",
    fill: "rgba(0,0,0,0.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    "data-name": "Path 2232",
    d: "M250.178,255.068a.994.994,0,0,1-.842,1.1H234.953a1.133,1.133,0,0,1,0-2.19h14.383A.994.994,0,0,1,250.178,255.068Z",
    transform: "translate(-234.111 -246.211)",
    fill: "rgba(0,0,0,0.4)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescription);
export default __webpack_public_path__ + "static/media/description.8e90561cd5c24c68786000b33edef29e.svg";
export { ForwardRef as ReactComponent };